import { UiStatus } from '../../../common/type';

export interface IAdsTypeInfo {
  idKey: string;
  name: string;
  basePrice: number;
}

export interface IAdsInfo {
  id: number;
  typeId: string;
  name: string;
}

/**
 * Discount type that applies for specific customer
 */
export enum CustomerDiscountType {
  PriceOverride,
  BulkPriceOverride,
  BulkBonusPack
}

export interface IPriceOverrideDiscount {
  type: CustomerDiscountType.PriceOverride;
  discountedPrice: number;
}

export interface IBulkPriceOverrideDiscount {
  type: CustomerDiscountType.BulkPriceOverride;
  discountedPrice: number;
  minQty: number;
}

export interface IBulkBonusPackDiscount {
  type: CustomerDiscountType.BulkBonusPack;
  packSize: number;
  freeQty: number;
}

export type ICustomerDiscount =
  | IPriceOverrideDiscount
  | IBulkPriceOverrideDiscount
  | IBulkBonusPackDiscount;

/**
 * Discount information for ads type
 */
export interface IAdsDiscount {
  adsTypeId: string;
  discount: ICustomerDiscount;
}

export interface ICustomerCustomPricing {
  customerId: string;
  discounts: IAdsDiscount[];
}

export enum CheckoutScreen {
  user = 'user',
  selection = 'selection',
  checkout = 'checkout'
}

/**
 * redux action type key
 */
export const enum AdsCheckoutActionKey {
  SetAdsTypeInfo = 'AdsCheckout/SetAdsTypeInfo',
  SetCustomerId = 'AdsCheckout/SetCustomerId',
  SetAds = 'AdsCheckout/SetAds',
  AddAds = 'AdsCheckout/AddAds',
  SetAdsName = 'AdsCheckout/SetAdsName',
  SetAdsType = 'AdsCheckout/SetAdsType',
  RemoveAds = 'AdsCheckout/RemoveAds',
  SetDiscounts = 'AdsCheckout/SetDiscounts',
  SetScreen = 'AdsCheckout/SetScreen',
  SetUiStatus = 'AdsCheckout/SetUiStatus',
  SetErrorMessage = 'AdsCheckout/SetErrorMessage'
}

/**
 * redux store
 */
export interface IAdsCheckoutModel {
  readonly customerId: string;
  readonly ads: IAdsInfo[];
  readonly adsTypeInfo: IAdsTypeInfo[];
  readonly discounts: IAdsDiscount[];
}

export interface IAdsCheckoutUi {
  readonly screen: CheckoutScreen;
  readonly status: UiStatus;
  readonly errorMessage: string;
}

export interface IAdsCheckoutStore {
  readonly model: IAdsCheckoutModel;
  readonly ui: IAdsCheckoutUi;
}



// WEBPACK FOOTER //
// ./src/modules/ads-checkout/parts/ads-checkout-type.ts